import React from "react";
import { CustomTextAreaProps } from "./types";
import { StyledTextArea } from "./styles";
import { Input } from "antd";

const { TextArea } = Input;

const CustomTextArea: React.FC<CustomTextAreaProps> = ({
  ...props
}): JSX.Element => {
  return (
    <StyledTextArea>
      <TextArea {...props} />
    </StyledTextArea>
  );
};

export default CustomTextArea;
